import FormContentCreateOrEditCreatorLinksItem from './FormContentCreateOrEditCreatorLinksItem';
import { useFormContext, useWatch } from 'react-hook-form';
import { Button, Input, Label } from '@/components/ui';
import { TProps } from '.';

const FormContentCreateOrEditCreatorLinks = ({ fieldNames, readonly = false }: TProps) => {

  const { setValue, control } = useFormContext();
  const links = useWatch({ control, name: fieldNames.links }) as string[] ?? [];

  const handleOnClickBtnAdd = () => {
    const newLinks = [...links, null];
    setValue(fieldNames.links, newLinks);
  };

  return (
    <div className='space-y-4'>
      <div className='flex flex-col gap-2'>
        <Label>
          Liens
          (<span className='text-purple-600'>
            {links.length}
          </span>)
        </Label>
        {
          links.length === 0
            ? <Input
              disabled
              className='text-center'
              value={'Non défini'} />
            : Array.from({ length: links.length }, (_, i) => i)
              .map(
                index => (
                  <FormContentCreateOrEditCreatorLinksItem
                    key={index}
                    index={index}
                    readonly={readonly}
                    name={fieldNames.links} />
                )
              )
        }
        {
          !readonly &&
          <div>
            <Button
              title='Ajouter un lien du créateur'
              onClick={handleOnClickBtnAdd}
              className='text-xs'
              variant={'outline'}
              size={'sm'} >
              Ajouter un lien
            </Button>
          </div>
        }
      </div>
    </div>
  );

};

export default FormContentCreateOrEditCreatorLinks;
